import { T } from "@supersig/validate";
import { cssTypeMap } from "./css";
export const variableTypeNumber = T.object({
    type: T.literal("variable-number"),
    value: T.number
});
export const variableTypeString = T.object({
    type: T.literal("variable-string"),
    value: T.string
});
export const variableTypeBoolean = T.object({
    type: T.literal("variable-boolean"),
    value: T.boolean
});
export const variableTypeMap = {
    "variable-number": variableTypeNumber,
    "variable-string": variableTypeString,
    "variable-boolean": variableTypeBoolean
};
export const variableTypes = T.union("type", variableTypeMap);
export const variableTypeToPrimitiveMapping = {
    "variable-number": "number",
    "varible-string": "string",
    "variable-boolean": "boolean"
};
export const variableValueTypes = T.union("type", {
    ...variableTypeMap,
    ...cssTypeMap
});
export const variablePrimitiveFromType = (type)=>{
    if (variableTypeMap[type]) {
        return "variable";
    }
    throw new Error(`Unknown type ${type}`);
};
